// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-b8226cca]{margin:0 2px}.p-card[data-v-b8226cca]{box-shadow:none}[data-v-b8226cca] .p-dialog .p-card .p-card-body{padding:0!important}", ""]);
// Exports
module.exports = exports;
